import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateEVSEMetadata } from '../../api/evse.ts';
import { UpdateEVSEMetadataRequest } from '../../api/requests/evse-request.ts';

export default function useUpdateEVSEMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateEVSEMetadata>>,
  Error,
  UpdateEVSEMetadataRequest
> {
  return useMutation({
    mutationFn: updateEVSEMetadata,
  });
}
